module.exports = __webpack_public_path__ + "static/hero-logo-18d68d143f4d8281fad8e92bd1df714e.svg";